import { TextField, InputAdornment } from "@mui/material";
import { useField } from "formik";
import React from "react";

const TextFieldWrapper = ({ name, label, startIcon, endIcon, ...otherProps }) => {
  const [field, meta] = useField(name);

  const configTextField = {
    ...field,
    ...otherProps,
    fullWidth: true,
    variant: "outlined",
  };

  if (meta?.touched && meta?.error) {
    configTextField.error = true;
    configTextField.helperText = meta.error;
  }

  if (startIcon) {
    configTextField.InputProps = {
      ...configTextField.InputProps,
      startAdornment: (
        <InputAdornment position="start">{startIcon}</InputAdornment>
      ),
    };
  }

  if (endIcon) {
    configTextField.InputProps = {
      ...configTextField.InputProps,
      endAdornment: (
        <InputAdornment position="end">{endIcon}</InputAdornment>
      ),
    };
  }

  return <TextField {...configTextField} label={label}  />;
};

export default TextFieldWrapper;
